import ReactDOM from "react-dom/client";
import React from "react";
import {SupportApp} from "./support/SupportApp";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import * as microsoftTeams from "@microsoft/teams-js";
import {AuthProvider as AppAuthProvider} from "./auth/AuthHook";

import "./tailwind.css";
import "./pygment_styles.css";
import {basePath} from "./utils/basePath";
import en from "./assets/locales/en.json";
import de from "./assets/locales/de.json";
import {setIsAccessedWithinTeams} from "./authConfig";
import {CookiesProvider} from "react-cookie";
import {BrowserRouter} from "react-router-dom";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime in v5)
        },
    },
});

const options = {
    resources: {
        en: {
            translation: en,
        },
        de: {
            translation: de,
        },
    },
    supportedLngs: ["en", "de"],
    fallbackLng: "en",
    debug: true,

    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    }
};
await i18n
    .use(initReactI18next)
    .init(options);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const renderApp = (showEmbedded: boolean) => {
    root.render(
        <QueryClientProvider client={queryClient}>
            {showEmbedded ? (
                <SupportApp basePath={basePath} allowCookieConsent={false} showEmbedded={true}/>
            ) : (
                <CookiesProvider defaultSetOptions={{path: '/'}}>
                    <BrowserRouter basename={basePath}>
                            <SupportApp basePath={basePath} allowCookieConsent={true} showEmbedded={false}/>
                    </BrowserRouter>
                </CookiesProvider>
            )}
        </QueryClientProvider>
    );
};

let showEmbedded = false;

try {
    await microsoftTeams.app.initialize();
    await microsoftTeams.authentication.getAuthToken({});
    setIsAccessedWithinTeams(true);
    showEmbedded = true;
} catch (error) {
    console.error("Error initializing Microsoft Teams SDK or getting auth token:", error);
}

renderApp(showEmbedded);
